'use client';

import { ChakraProvider } from '@chakra-ui/react';
import system from '../theme';
import { Toaster } from '../components/core/toaster';

interface ProviderProps {
  children: React.ReactNode;
}

export const Provider: React.FC<ProviderProps> = ({ children }) => {
  return (
    <ChakraProvider value={system}>
      {children}
      <Toaster />
    </ChakraProvider>
  );
};
